import React, { useEffect, useState } from 'react';
import { withStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import { ClosedCaption } from '@mui/icons-material';
import { Box } from '@mui/material';
import RoundedButton from '@app/components/atoms/RoundedButton';
import PropTypes from 'prop-types';
import { useTranslation } from '@app/config/i18n';
import CustomDialog from '@app/components/molecules/CustomDialog';

const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  imgContainer: {
    position: 'relative',
    flex: 1,
    padding: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
};

const Transition = (props) => <Slide direction="up" {...props} />;

const ImgDialog = ({ classes, img, onClose, saveImage }) => {
  const { t } = useTranslation(['common', 'account']);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(!!img);
  }, [img]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    setOpen(false);
    saveImage();
  };

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      TransitionComponent={Transition}
    >
      <div>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton color="inherit" onClick={onClose} aria-label="Close">
              <ClosedCaption />
            </IconButton>
            <Typography variant="title" color="inherit" className={classes.flex}>
              {t('cropped_img')}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.imgContainer}>
          <img src={img} alt="Cropped" className={classes.img} />
        </div>

        <Box display="flex" justifyContent="end" p={4} gap={2}>
          <RoundedButton onClick={handleClose} variant="outlined" color="primary">
            {t('cancel')}
          </RoundedButton>

          <RoundedButton onClick={handleSave} variant="contained" color="primary">
            {t('save')}
          </RoundedButton>
        </Box>
      </div>
    </CustomDialog>
  );
};

ImgDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  saveImage: PropTypes.func.isRequired,
  img: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImgDialog);
